// Admin API client — /admin/projects/* (mirrors the API's projects aggregate).

import { client } from './transport';

export const projectsApi = {
  // ASC vendor number (support backstop)
  // These hit the admin-scoped routes on a7y-api:
  //   GET  /admin/projects/:projectId/store-link/asc
  //   PATCH /admin/projects/:projectId/store-link/vendor-number
  // Used to let a support operator set/correct the Apple Sales & Trends
  // vendor number on a project's ASC store link without re-uploading the .p8.
  //
  // Note: the GET route returns the ASC store-link fields directly (not
  // wrapped in { storeLink, success }), since it's a read-only snapshot.
  getProjectAscStoreLink: (projectId: string) =>
    client.get<{
      vendor_number?: string;
      vendor_number_missing?: boolean;
      permission_error?: unknown;
      [key: string]: unknown;
    }>(`/projects/${projectId}/store-link/asc`),
  updateProjectAscVendorNumber: (projectId: string, vendorNumber: string) =>
    client.patch<{
      success: boolean;
      vendor_number: string;
    }>(`/projects/${projectId}/store-link/vendor-number`, {
      vendor_number: vendorNumber,
    }),
};
